import { Arrow } from 'components/icons/Arrow';
import Link from 'next/link';
import Cover from 'public/images/CategoriesCover.png';
import { categories } from 'utils/hardcoded-data';

const CategoriesPage = () => {
  return (
    <div>
      <div
        className="px-8 py-16 rounded-xl"
        style={{
          backgroundImage: `url(${Cover.src})`,
          backgroundSize: 'cover'
        }}
      >
        <div className="max-w-[500px] flex flex-col gap-4">
          <ul className="flex gap-1 items-center text-sm text-stone-300">
            <li>
              <Link href="/">Home</Link>
            </li>
            <Arrow className="w-4 h-4 -rotate-90" />
            <li>
              <Link href="/categories">Categories</Link>
            </li>
          </ul>
          <h1 className="text-3xl uppercase">Categories</h1>
          <p className="text-stone-300">
            Easily navigate through all the categories on the site. Find the girl of your dreams and start chatting with
            her!
          </p>
          <Link prefetch={false} href="/" className="btn contained primary w-fit mt-3">
            Browse All Girls
          </Link>
        </div>
      </div>

      {categories.map(({ title, data }, i) => (
        <div key={i} className="w-full flex px-10 py-14 border-b border-b-1 border-primary">
          <h2 className="text-2xl mb:mr-0 md:w-[300px] w-[200px] mr-3">{title}</h2>
          <ul className="w-full grid md:grid-cols-3 sm:grid-cols-2 grid-cols-1">
            {data.map(([keyword, url]) => (
              <li key={keyword} className="p-2 hover:text-brand w-fit">
                <Link prefetch={false} href={`${url}`}>
                  {keyword}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default CategoriesPage;
